import { render, staticRenderFns } from "./Settlements.vue?vue&type=template&id=696b2fa1&"
import script from "./Settlements.vue?vue&type=script&lang=js&"
export * from "./Settlements.vue?vue&type=script&lang=js&"
import style0 from "./Settlements.vue?vue&type=style&index=0&id=696b2fa1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports